module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500.woff?cea99d3e3e13a3a599a015c29f1046d0";